import React from 'react'
// import { Link } from 'react-router-dom'
// import Card from '../components/Card'

export default function ProductOfferings() {
  // Define offerings and rows arrays
  const offerings = [
    {
      name: "Administrative Support",
      description: "Assistance to help you achieve administrative related tasks on projects",
      deliveryModel: ["Monthly", "Per Hour", "Fixed per Project"],
      deliverable: ["Contracted Labor"],
      tools: ["Client provided", "Basic microsoft products", "Discuss with 1OPSS"],
      dataHosting: ["Client provided", "Discuss with 1OPSS"],
      pricing: {
        monthly: "$50",
        perHour: "$50",
        fixed: "Discuss with 1OPSS"
      }
    },
    {
      name: "Bookkeeping",
      description: "Reliable Accounting. Clear Numbers. Confident Decisions. From bookkeeping to tax preparation, we help you stay compliant, organized, and financially confident—so you can focus on what matters most.\n✔ Accurate\n✔ On time\n✔ Stress-free\nSchedule your consultation today.",
      deliveryModel: ["Monthly", "Per Hour", "Fixed per Project"],
      deliverable: ["Contracted Labor", "Transaction Entries", "Trial Balance"],
      tools: ["Client provided", "Basic microsoft products", "Discuss with 1OPSS"],
      dataHosting: ["Client provided", "Discuss with 1OPSS"],
      pricing: {
        monthly: "$50",
        perHour: "$50",
        fixed: "Discuss with 1OPSS"
      }
    },
    {
      name: "Financial Reporting",
      description: "Accounting Support",
      deliveryModel: ["Monthly", "Per Hour", "Fixed per Project"],
      deliverable: ["Contracted Labor", "Financial Report"],
      tools: ["Client provided", "Basic microsoft products", "Discuss with 1OPSS"],
      dataHosting: ["Client provided", "Discuss with 1OPSS"],
      pricing: {
        monthly: "$50",
        perHour: "$50",
        fixed: "Discuss with 1OPSS"
      }
    },
    {
      name: "Business Process Support & Monitoring",
      description: "",
      deliveryModel: ["Monthly", "Per Hour", "Fixed per Project"],
      deliverable: ["Contracted Labor", "Variance reporting"],
      tools: ["Client provided", "Basic microsoft products", "Discuss with 1OPSS"],
      dataHosting: ["Client provided", "Discuss with 1OPSS"],
      pricing: {
        monthly: "$50",
        perHour: "$50",
        fixed: "Discuss with 1OPSS"
      }
    },
    {
      name: "Budget Preparation",
      description: "",
      deliveryModel: ["Monthly", "Per Hour", "Fixed per Project"],
      deliverable: ["Budget Preparation"],
      tools: ["Client provided", "Basic microsoft products", "Discuss with 1OPSS"],
      dataHosting: ["Client provided", "Discuss with 1OPSS"],
      pricing: {
        monthly: "$50",
        perHour: "$50",
        fixed: "Discuss with 1OPSS"
      }
    }
  ];

  const rows = [
    { label: "Service Description", key: "description" },
    { label: "Service Delivery Model", key: "deliveryModel" },
    { label: "Expected Deliverable", key: "deliverable" },
    { label: "Project Execution Tools", key: "tools" },
    { label: "Data Hosting", key: "dataHosting" },
    { label: "Pricing", key: "pricing" }
  ];

  return (
    // <div className="container">
    //   <section className="card">
    //     <div style={{display:'flex', gap:12, flexWrap:'wrap'}}>
    //       <input placeholder="Search bookkeepers, software, or skill" style={{padding:12, borderRadius:8, border:'1px solid #eef6ff', flex:1}}/>
    //       <select style={{padding:12, borderRadius:8, border:'1px solid #eef6ff', maxWidth:220}}>
    //         <option>All specialties</option>
    //         <option>Taxes</option>
    //         <option>QuickBooks</option>
    //         <option>Payroll</option>
    //       </select>
    //       <select style={{padding:12, borderRadius:8, border:'1px solid #eef6ff', maxWidth:180}}>
    //         <option>Sort: Recommended</option>
    //         <option>Highest rated</option>
    //         <option>Lowest price</option>
    //       </select>
    //     </div>

    //     <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:16, marginTop:16}}>
    //       <Card>
    //         <div style={{display:'flex', gap:12, alignItems:'center'}}>
    //           <div style={{width:64, height:64, borderRadius:12, background:'#f1f6ff'}} />
    //           <div>
    //             <div style={{fontWeight:700}}>Sarah P.</div>
    //             <div className="kv">Taxes • QuickBooks • Small Business</div>
    //           </div>
    //           <div style={{marginLeft:'auto', textAlign:'right'}}>
    //             <div style={{fontWeight:700, color:'var(--accent-600)'}}>$45/hr</div>
    //             <Link to="/profile/1" className="btn ghost" style={{marginTop:8}}>View</Link>
    //           </div>
    //         </div>
    //       </Card>

    //       <Card>
    //         <div style={{display:'flex', gap:12, alignItems:'center'}}>
    //           <div style={{width:64, height:64, borderRadius:12, background:'#f1f6ff'}} />
    //           <div><div style={{fontWeight:700}}>Ryan S.</div><div className="kv">Small Business • Payroll</div></div>
    //           <div style={{marginLeft:'auto'}}><div style={{fontWeight:700, color:'var(--accent-600)'}}>$50/hr</div><Link to="/profile/2" className="btn ghost" style={{marginTop:8}}>View</Link></div>
    //         </div>
    //       </Card>

    //       <Card>
    //         <div style={{display:'flex', gap:12, alignItems:'center'}}>
    //           <div style={{width:64, height:64, borderRadius:12, background:'#f1f6ff'}} />
    //           <div><div style={{fontWeight:700}}>April C.</div><div className="kv">Personal Finance</div></div>
    //           <div style={{marginLeft:'auto'}}><div style={{fontWeight:700, color:'var(--accent-600)'}}>$60/hr</div><Link to="/profile/3" className="btn ghost" style={{marginTop:8}}>View</Link></div>
    //         </div>
    //       </Card>
    //     </div>

    //     <div style={{textAlign:'center', marginTop:12}}>
    //       <button className="btn ghost">Load more</button>
    //     </div>
    //   </section>
    // </div>
    <div className="container">
      <section className="card">
        <h2 className="h2" style={{marginBottom:24}}>Product Offerings</h2>
        <div style={{overflowX:'auto'}}>
          <table className="offerings-table" style={{width:'100%', borderCollapse:'collapse', minWidth:800}}>
            <thead>
              <tr>
                <th style={{background:'#f7faff', textAlign:'left', padding:'12px 16px', fontWeight:700}}> </th>
                {offerings.map(offering => (
                  <th key={offering.name} style={{background:'#f7faff', textAlign:'left', padding:'12px 16px', fontWeight:700}}>{offering.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map(row => (
                <tr key={row.label}>
                  <td style={{background:'#f7faff', fontWeight:600, padding:'12px 16px'}}>{row.label}</td>
                  {offerings.map(offering => (
                    <td key={offering.name + row.label} style={{padding:'12px 16px', verticalAlign:'top', borderBottom:'1px solid #eef6ff'}}>
                      {row.key === 'pricing' ? (
                        <div>
                          <div><strong>Monthly:</strong> {offering.pricing.monthly}</div>
                          <div><strong>Per Hour:</strong> {offering.pricing.perHour}</div>
                          <div><strong>Fixed per Project:</strong> {offering.pricing.fixed}</div>
                        </div>
                      ) : Array.isArray(offering[row.key]) ? (
                        offering[row.key].map((item, idx) => <div key={idx}>{item}</div>)
                      ) : (
                        <div style={{whiteSpace:'pre-line'}}>{offering[row.key]}</div>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  )
}
